











import { Component, Vue,Prop } from 'vue-property-decorator'
import {MDCChipSet} from '@material/chips'
@Component({})
export default class MdcChipSet extends Vue{
  chipSet?:MDCChipSet
  @Prop({default:'div'}) tag!:string

  @Prop({default:false}) filter!:boolean
  @Prop({default:false}) input!:boolean
  @Prop({default:false}) choice!:boolean

  @Prop({default:true}) js!:boolean

  onInteraction(e:Event):void{
    this.$emit('MDCChip:interaction',e)
  }
  onSelection(e:Event):void{
    this.$emit('MDCChip:selection',e)
  }
  onRemoval(e:Event):void{
    this.$emit('MDCChip:removal',e)
  }
  mounted(){
    if(this.js){
      this.chipSet = new MDCChipSet(this.$el)
      this.chipSet.listen('MDCChip:interaction',e=>this.onInteraction(e))
      this.chipSet.listen('MDCChip:selection',(e)=>this.onSelection(e))
      this.chipSet.listen('MDCChip:removal',(e)=>this.onRemoval(e))
    }
  }
  beforeDestroy(){
    if(this.chipSet){
      this.chipSet.destroy()
    }
  }
}
